import React from 'react';
import styled from '@emotion/styled';

import { ProductBelowAtfBadgeList } from '@domains/pdp-common';

interface Props {
  badgeList: ProductBelowAtfBadgeList[];
}

export const BadgeList: React.FC<React.PropsWithChildren<Props>> = ({ badgeList }) => {
  return (
    <List>
      {badgeList.map((badge) => (
        <Badge key={badge.image_url} src={badge.image_url} alt={`${badge.type ?? ''} 뱃지`} />
      ))}
    </List>
  );
};

const List = styled.div`
  position: relative;
  margin: 7px 0 0 0;
  display: flex;
  row-gap: 8px;
  flex-wrap: wrap;
`;

const Badge = styled.img`
  margin: 0 4px 0 0;
  width: auto;
  height: 20px;
`;
